module.exports = __webpack_public_path__ + "static/img/bg.26c47e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Order/images/bg.png
// module id = z2Ee
// module chunks = 169